// constants.js file
export const BASE_URL = "https://dsider.co/static/media/";
